import React from 'react';
import { connect } from 'react-redux';
import { DBDecimalFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationCircumferenceNavicular extends React.Component {

    render() {
        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Circumference - Navicular Level' />
                <label className={styles.label}>Navicular Level</label>
                <span className={styles.circum_column}>
                    <DBDecimalFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOCIRNAVICULARR'
                        className={styles.circum_input}
                        min={0}
                    />
                    <label>&nbsp;&nbsp;cm</label>
                </span>
                <span className={styles.circum_column}>
                    <DBDecimalFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOCIRNAVICULARL'
                        className={styles.circum_input}
                        min={0}
                    />
                    <label>&nbsp;&nbsp;cm</label>
                </span>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRNAVICULARR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRNAVICULARR !== null)
            || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRNAVICULARL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRNAVICULARL !== null)
            ? true : false
    };
}

const connectedObservationCircumferenceNavicular = connect(mapStateToProps)(ObservationCircumferenceNavicular);
export { connectedObservationCircumferenceNavicular as ObservationCircumferenceNavicular };


